(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/accessibility/assets/javascripts/behaviors/ui-focus-disable.js') >= 0) return;  svs.modules.push('/components/numbergames/accessibility/assets/javascripts/behaviors/ui-focus-disable.js');

'use strict';

svs.numbergames.accessibility.behaviors.UIFocusDisable = Marionette.Behavior.extend({
  onInitialize() {
    if (typeof this.view.events === 'object') {
      for (const event of Object.keys(this.view.events)) {
        if (/^click/i.test(event)) {
          this.override(event, this.view.events[event]);
        }
      }
    }
    if (typeof this.view.triggers === 'object') {
      for (const trigger of Object.keys(this.view.triggers)) {
        if (/^click/i.test(trigger)) {
          const callee = this.view.triggers[trigger];
          const action = "on".concat(callee[0].toUpperCase() + callee.substring(1));
          this.override(trigger, action);
        }
      }
    }
  },
  override(event, action) {
    var _this = this;
    const originalAction = this.view[action];
    if (originalAction) {
      this.view[action] = function () {
        var _event$match;
        const uiStr = (_event$match = event.match(/@ui\.[a-z]+/i)) === null || _event$match === void 0 ? void 0 : _event$match[0].replace('@ui.', '');
        if (_this.getUI(uiStr).attr('aria-disabled') === 'true') {
          svs.numbergames.accessibility.logger.debug("\"aria-disabled\" for selector \"".concat(uiStr, "\" is \"true\", preventing action."));
          return;
        }
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        originalAction.apply(_this.view, args);
      };
    }
  },
  onDisableUI($el) {
    $el.attr('aria-disabled', 'true');
    $el.addClass('disabled'); 
  },
  onEnableUI($el) {
    $el.attr('aria-disabled', 'false');
    $el.removeClass('disabled'); 
  },
  onToggleUI($el, isDisabled) {
    switch (isDisabled) {
      case undefined:
        this.onToggleUI($el, $el.attr('aria-disabled') === 'true');
        break;
      case true:
        this.onDisableUI($el);
        break;
      case false:
        this.onEnableUI($el);
        break;
    }
  }
});

 })(window);